const En = {
  '工作站': 'Work'
}
export default En



// WEBPACK FOOTER //
// ./src/lang/en.js